import { NgModule } from '@angular/core';
import { TimeLimitGarageControlService } from './time-limit-garage-control.service';
import { TimeLimitGaragePanelStructureColorService } from './time-limit-garage-panel-structure-color.service';

@NgModule({
    providers: [
        TimeLimitGarageControlService,
        TimeLimitGaragePanelStructureColorService,
    ],
})
export class GarageDoorTimeLimitModule {}
